export default "__VITE_ASSET__DOFk4yrs__"